
<template>
  <div>
    <v-dialog v-model="dialog" scrollable max-width="700px" transition="dialog-transition" >
      <v-card style="border-radius:12px" v-if="oneCustomField" :outlined="$vuetify.theme.isDark">
        <v-card-title primary-title>
          <div class="headline mb-0">Importação</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-col class="pt-0 px-0">
            <v-subheader>Cabeçalhos suportados:</v-subheader>
            <v-row class="px-3">
              <v-chip small class="ma-1" v-for="(h,idx) in available_headers" :key="h">{{h}}</v-chip>
            </v-row>
          </v-col>
          <v-col class="px-0">
            <v-form ref="csvForm">
              <v-file-input
                v-model="file"
                :rules="rules"
                show-size
                accept=".csv"
                placeholder="Escolha o arquivo csv"
                prepend-icon="mdi-file-excel"
                label="CSV"
                @click:clear="resetParseResult"
                color="secondary"
              >
                <template v-slot:selection="{ text }">
                  <v-chip small label color="secondary" >
                    {{ text }}
                  </v-chip>
                </template>
              </v-file-input>
              <v-row class="px-3" justify="end">
                <v-btn :disabled="!file" @click="submitFile()" color="secondary"> <v-icon left>mdi-swap-horizontal-bold</v-icon> Converter</v-btn>
              </v-row>
            </v-form>
          </v-col>
          <v-col v-if="parse_result.data && parse_result.data.length">
            <v-subheader>Amostra da importação</v-subheader>
            <v-data-table
              :headers="preview_table_header"
              :items="parse_result.data" 
              class="elevation-2"
              mobile-breakpoint='1'
            >
              <!-- hide-default-footer -->
            </v-data-table>
          </v-col>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <template v-if="has_main">
            <v-btn @click="closeDialog()" text color="error">Cancelar</v-btn>
            <v-btn @click="submitCustomValues()" color="success"> <v-icon left>mdi-content-save</v-icon> importar</v-btn>
          </template>
          <template v-if="!has_main">
            <v-alert type="error" :value="true">
              <div>
                Atenção, o cabeçalho "{{oneCustomField.main_field}}" é obrigatório pois ele representa o campo principal! 
              </div>
              <div>
                Altere sua planilha e tente novamente.
              </div>
            </v-alert>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <dialog-loading v-if="loading" :loadingText="loadingText"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '../../../api/index'

export default {
  name: 'DialogImportCsv',
  props: {
    cv_id: {
      type: Number,
    }
  },
  data() {
    return {
      dialog: true,
      file: null,
      parse_result: {},
      rules: [
        v => !!v || 'Arquivo é obrigatório', 
        value => !value || value.size < 5000000 || 'Tamanho do arquivo CSV deve ser menor que 5 MB!',
      ],

      loading: false,
      loadingText: null,

      preview_table_header: []
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false
    },
    resetParseResult(){
      this.parse_result = {}
      this.preview_table_header = []
    },
    setParseResult(results){
      this.parse_result = {...results}
    },
    setDataToSubmit(){
      return this.parse_result.data.map(r=> {
        let r2 = {...r}
        delete r2.null
        return {
          custom_field_id: this.oneCustomField.id,
          content: {...r2},
          main: r[this.oneCustomField.main_field_uuid]
        }
      })
    },
    async submitFile(){
      this.resetParseResult()
      const self = this
      
      let available_headers = this.available_headers
      let headers_uuid_map = this.headers_uuid_map

      let b = await this.$ppp.parse(this.file, {
        header: true,
        skipEmptyLines: true,
        complete: function(results, file) {
          // console.log("Parsing complete:", results);
          self.setParseResult(results)
        },
        error: function(results, file) {
          // console.log("Parsing failed:", results, file);
        },
        transform: function (value){
          value = value.trim()
          return value
        },
        transformHeader: function(header, index) {
          // console.log(available_headers);
          if ( !available_headers.includes(header.toUpperCase())){
            header = null
          } else {
            self.preview_table_header.push({
              text: header.toUpperCase(),
              value: headers_uuid_map[available_headers.indexOf(header.toUpperCase())]
            })
            header = headers_uuid_map[available_headers.indexOf(header.toUpperCase())]
          }
          return header
        }
      })
    },
    async submitCustomValues(){
      if (this.$refs.csvForm.validate()){
        if (this.parse_result.data && this.parse_result.data.length){
          let title = `Importar registros?`
          let { value: confirmation } = await this.$swal({
            title,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sim",
            confirmButtonColor: "#270b42",
            cancelButtonText: "Não"
          });
          if (confirmation) {
            this.loading = true
            this.loadingText = 'Importando'
            this.importCsv()
          }
        } else {
          const notification = {
            msg: 'É necessário converter o arquivo primeiro',
            type: 'error',
          }
          this.addNotification(notification)
        }
      }
    },
    findDuplicates(arr){
      let sorted_arr = arr.map(a=> a.main).slice().sort(); 
      
      let results = [];
      for (let i = 0; i < sorted_arr.length - 1; i++) {
        if (sorted_arr[i + 1] == sorted_arr[i]) {
          results.push(sorted_arr[i]);
        }
      }
      return results;
    },
    importCsv(){
      let obj = {
        id: this.oneCustomField.id,
        custom_values_attributes: this.setDataToSubmit()
      }
      let dups = this.findDuplicates(obj.custom_values_attributes)
      if (dups.length > 0){ 
        const notification = {
            msg: `Os registros ${dups.join(', ')} estão duplicados. Por favor, retire-os para prosseguir.`,
            type: 'error',
          }
          this.addNotification(notification)
          this.loading = false
      } else {
        Api.CustomValue.importCsv(obj).then(r=> r.data).then(cvs=> {
          let msg = `${cvs.obj_count} enviados, ${cvs.created} criados e ${cvs.updated} atualizados.`
          const notification = {
            msg: `Sucesso! ${msg}`,
            type: 'success',
          }
          this.addNotification(notification)
          this.$emit('done', cvs.created)
        }).catch(err=>{
          const notification = {
            msg: err,
            type: 'error',
          }
          this.addNotification(notification)
        }).finally(()=>{
          this.loading = false
          this.loadingText = null
        })
      }
    },
    ...mapActions({
      addNotification: "Notification/add",
      showCustomField: 'CustomField/show',
    })
  },
  computed: {
    available_headers() {
      if (this.oneCustomField){
        let h = []
        for (const k in this.oneCustomField.fields) {
          if (this.oneCustomField.fields.hasOwnProperty(k)) {
            const element = this.oneCustomField.fields[k];
            h.push(element.key.toUpperCase())
          }
        }
        return h
      }
    },
    headers_uuid_map() {
      if (this.oneCustomField){
        let h = []
        for (const k in this.oneCustomField.fields) {
          if (this.oneCustomField.fields.hasOwnProperty(k)) {
            const element = this.oneCustomField.fields[k];
            h.push(element.uuid)
          }
        }
        return h
      }
    },
    has_main(){
      if (this.preview_table_header.length) {
        return this.preview_table_header.findIndex(h=> h.value == this.oneCustomField.main_field_uuid) > -1
      }
      return true
    },
    ...mapState({
      oneCustomField: state => state.CustomField.oneCustomField,
    })
  },
  mounted () {
    if (!this.oneCustomField && this.cv_id){
      this.showCustomField(this.cv_id).then(() => {})
    }
  },
  watch: {
    dialog(nv,ov) {
      if (nv){
      } else if (nv == false){
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>

</style>
